import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { VoucherForCampaignNewItem_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useCreateNewCampaignQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(VoucherForCampaignNewItem_EditPage_Query, {
		variables: { hotelID },
	});

	return { data };
};
